import { Controller } from "@hotwired/stimulus";
import { AdjustHeight } from "../shared/adjust_height";

// Connects to data-controller="resumin--entry-email-compose"
export default class extends Controller {
  static targets = [
    "senderName",
    "companyName",
    "contactName",
    "subject",
    "body",
  ];

  connect() {
    AdjustHeight(this);
  }

  reflect(e) {
    e.preventDefault();

    const senderName = this.senderNameTarget.value;
    const companyName = this.companyNameTarget.value;
    const contactName = this.contactNameTarget.value || "ご担当者";

    this._setSubject(senderName);
    this._setBody(senderName, companyName, contactName);
    this._adjustTextareaHeight();
  }

  _setSubject(senderName) {
    this.subjectTarget.value = `履歴書送付のご連絡（${senderName}）`;
  }

  _setBody(senderName, companyName, contactName) {
    const body = `${companyName}
${contactName} 様

お世話になっております。
${senderName} と申します。

この度貴社に応募させていただきたく、履歴書を送付いたします。

お手数をおかけしますが、ご査収のほどよろしくお願いいたします。`;

    this.bodyTarget.value = body;
  }

  _adjustTextareaHeight() {
    const body = this.bodyTarget;
    this.adjustElementHeight(body);
  }
}
